import Notification from '../interfaces/Notification';
import { STATUS } from '../../../enum/status/Status';

export const INITIAL_VALUES: Notification = {
    title: '',
    ticket: '',
    type: STATUS.Overview,
    idpais: 0,
    UUNNStoresAffected: '',
    affectedFlag: [],
    faultDescription: '',
    serviceHealthBusiness: '',
    initialAffectedService: '',
    initialImpact: '',
    timeFaulIdentified: '',
}